export default "images/hongqi.png";